import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70 text-center">
            <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 mb-5">
              <i className="ri-smartphone-line text-2xl"></i>
            </span>

            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto mb-6">
              {appData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-50 text-secondary-700 text-xs font-medium rounded-full"
                >
                  <i className="ri-check-line"></i>
                  {feat}
                </span>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即开始观影
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}